export default __webpack_public_path__ + "static/media/icon-accidente-sin-deducible.e864e58b.svg";